import FirendBaseItem from "./friend_base_item";
import EventManager from "../../../../../manager/event_manager";
import UserDataManager from "../../../../../manager/user_manager";
import PlayerIconModule from "../../playericon/playerIcon";
import ModuleManager from "../../../../../framework/core/module_manager";
import Utility from "../../../../../utility/utility";
import ComponentBase from "../../../../public/component/component_base";
import { IUserData } from "../../../../public/model_data";

const {ccclass, property} = cc._decorator;

@ccclass
export default class FriendSearchItem extends ComponentBase{

   
    @property(cc.Label)
    nameLabel: cc.Label = null;

    @property(cc.Sprite)
    iconSprite: cc.Sprite = null;

    @property(cc.Label)
    level : cc.Label = null;

    @property([cc.Node])
    gender : cc.Node[] = [];

    private friendId : number;

    public updateInfo(data: any) {

        this.friendId = data.gameUserId;

        this.node.active = true;

        this.nameLabel.string = data.nickname;

        if (data.gender && this.gender.length > 0) {

            this.gender.forEach((node, index) => {
                if (index == data.gender - 1) {
                    node.active = true;
                } else {
                    node.active = false;
                }
            });
        }

        this.level.string = "LV." + data.userLevel;

        // UserDataManager.getAvatarSprite(data.headImg, (spriteFrame) => {
        //     this.iconSprite.spriteFrame = spriteFrame
        // });

        let self = this;
        this.getUserData(this.friendId,(data:IUserData)=>{
            if (self.friendId == data.id) {
                self.iconSprite.spriteFrame = data.avatarSprite;
            }
        });

    }

    onAdd(){

        Utility.playButtonSound()
        EventManager.instance.dispatch("request_add_friend",this.friendId);
    }

    onItem(){

        Utility.playButtonSound()
        ModuleManager.instance.showModule<PlayerIconModule>(PlayerIconModule,{userId:this.friendId,other:true})

    }
  
}
